import script from "./ProjectCardMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCardMenu.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCardMenu.vue?vue&type=style&index=0&id=1f4ffdd4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4ffdd4"]])

export default __exports__